export default __webpack_public_path__ + "static/media/Inifinity Car - Logo2.a6232170.png";